import React from 'react';
import { useTranslation } from 'react-i18next';
import FormikCheckbox from '../../base/forms/formikCheckbox';
import { A, P } from '../../base/typography';
import InactiveStep from '../InactiveStep';
import { useMultiStepFormContext } from '../context/multistepContext';
import { useTranslationsContext } from '../context/translationsContext';
import { FormStepProps } from '../sendReceiptMultistep';
import {
	ButtonWrapper,
	FormStepHeading,
	FormStepWrapper,
	PrevButton,
	PrevButtonMobile,
	ProceedButton,
} from '../sendReceiptMultistep.styles';
import { DELIVERY_STEP_INDEX } from './Delivery/Delivery';
import { INSTRUCTIONS_TO_STAFF_STEP_INDEX } from './InstructionToStaff/InstructionToStaff';

export const TERMS_STEP_INDEX = 5;

export default function Terms({ setFieldValue, values, errors, touched }: FormStepProps) {
	const translations = useTranslationsContext();
	const { currentStepIndex, latestStepIndexVisited, goTo } = useMultiStepFormContext();
	const { t } = useTranslation('sendReceiptMultistep');

	if (currentStepIndex !== TERMS_STEP_INDEX && latestStepIndexVisited >= TERMS_STEP_INDEX)
		return (
			<InactiveStep
				heading={translations?.inactiveTitles?.terms || t('inactiveTitles.terms')}
				onClick={() => goTo(TERMS_STEP_INDEX)}
				touched={touched}
				errors={errors}
			/>
		);

	const isStepStateValid = values.acceptedTerms && !errors.acceptedTerms;

	if (currentStepIndex === TERMS_STEP_INDEX)
		return (
			<FormStepWrapper>
				<PrevButtonMobile
					onClick={e => {
						e.stopPropagation();
						if (values.instructionsToStaff === 'hasInvoice') {
							goTo(DELIVERY_STEP_INDEX);
						} else {
							goTo(INSTRUCTIONS_TO_STAFF_STEP_INDEX);
						}
					}}>
					{translations?.prevStepMobile || t('prevStepMobile')}
				</PrevButtonMobile>
				<FormStepHeading>{translations?.formStepTitles?.terms || t('formStepTitles.terms')}</FormStepHeading>
				<P>{translations?.terms?.explanation || t('terms.explanation')}</P>
				<FormikCheckbox
					name="acceptedTerms"
					id="acceptedTerms"
					label={
						<>
							{translations?.terms?.agreeText || t('terms.agreeText')}
							<A blank to={translations?.terms?.termsLinkUrl || t('terms.termsLinkUrl')}>
								{translations?.terms?.termsLinkText || t('terms.termsLinkText')}
							</A>
						</>
					}
					setFieldValue={setFieldValue}
				/>
				<ButtonWrapper marginTop="1rem">
					<PrevButton
						onClick={e => {
							e.stopPropagation();
							if (values.instructionsToStaff === 'hasInvoice') {
								goTo(DELIVERY_STEP_INDEX);
							} else {
								goTo(INSTRUCTIONS_TO_STAFF_STEP_INDEX);
							}
						}}>
						{translations?.prevStep || t('prevStep')}
					</PrevButton>
					<ProceedButton type="submit" disabled={!isStepStateValid}>
						{translations?.confirm || t('confirm')}
					</ProceedButton>
				</ButtonWrapper>
			</FormStepWrapper>
		);

	return null;
}
